export type HoursWeekday = "1" | "2" | "3" | "4" | "5" | "6" | "7";
export interface HoursDay {
  open: string;
  close: string;
}
export type HoursValue = Record<HoursWeekday, HoursDay | null>;

const LABELS: Record<HoursWeekday, string> = {
  "1": "Lundi",
  "2": "Mardi",
  "3": "Mercredi",
  "4": "Jeudi",
  "5": "Vendredi",
  "6": "Samedi",
  "7": "Dimanche",
};
const DAYS = Object.keys(LABELS) as HoursWeekday[];

/** Heures d'ouverture par jour : une case « ouvert » et deux heures. */
export function HoursEditor({
  value,
  onChange,
}: {
  value: HoursValue;
  onChange: (next: HoursValue) => void;
}) {
  const setDay = (day: HoursWeekday, next: HoursDay | null) => onChange({ ...value, [day]: next });
  return (
    <ul className="hours">
      {DAYS.map((day) => {
        const v = value[day];
        return (
          <li key={day} className={`hours__day${v ? "" : " hours__day--closed"}`}>
            <label className="hours__toggle">
              <input
                type="checkbox"
                checked={v !== null}
                onChange={(e) =>
                  setDay(day, e.target.checked ? { open: "08:00", close: "17:30" } : null)
                }
              />
              <span>{LABELS[day]}</span>
            </label>
            {v ? (
              <span className="hours__range">
                <input
                  type="time"
                  className="input hours__time"
                  aria-label={`${LABELS[day]} — ouverture`}
                  value={v.open}
                  onChange={(e) => setDay(day, { ...v, open: e.target.value })}
                />
                <span className="hours__sep">à</span>
                <input
                  type="time"
                  className="input hours__time"
                  aria-label={`${LABELS[day]} — fermeture`}
                  value={v.close}
                  onChange={(e) => setDay(day, { ...v, close: e.target.value })}
                />
              </span>
            ) : (
              <span className="hours__closed">Fermé</span>
            )}
          </li>
        );
      })}
    </ul>
  );
}
